import { create } from "zustand";
import { persist } from "zustand/middleware";

type State = {
    user: any;
    auth0Login: boolean;
    auth0ButtonClicked: boolean;
    appLoader: boolean;
    manualRefreshToken: boolean;
}

type Actions = {
    setUser: (user: any) => void;
    setAuth0Login: (auth0: any) => void;
    setAuth0ButtonClicked: (auth0: any) => void;
    setAppLoader: (appLoader: boolean) => void;
    setManualRefreshToken: (manualRefreshToken: boolean) => void;
}

export const useCustomStore = create<State & Actions>()(
    persist<State & Actions>(
        (set) => ({
            user: null,
            auth0Login: false,
            auth0ButtonClicked: false,
            appLoader: false,
            manualRefreshToken: false,
            setUser: (user: any) => set({ user }),
            setAuth0Login: (auth0Login: boolean) => set({ auth0Login }),
            setAuth0ButtonClicked: (auth0ButtonClicked: boolean) => set({ auth0ButtonClicked }),
            setAppLoader: (appLoader: boolean) => set({ appLoader }),
            setManualRefreshToken: (manualRefreshToken: boolean) => set({ manualRefreshToken }),
        }), {
        name: 'customer-store'
    })
);